import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';

// Public pages
import Home from './pages/Home';
import DomainDetail from './pages/DomainDetail';
import BrowseNiche from './pages/BrowseNiche';
import BulkCheck from './pages/BulkCheck';
import Marketplaces from './pages/Marketplaces';
import WhyFree from './pages/WhyFree';
import SerpScanner from './pages/SerpScanner';
import Compare from './pages/Compare';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import OAuthCallback from './pages/OAuthCallback';
import Submit from './pages/Submit';
import ApiDocs from './pages/ApiDocs';
import Privacy from './pages/Privacy';
import Partners from './pages/Partners';
import McpServer from './pages/McpServer';
import Campaigns from './pages/Campaigns';
import CampaignNew from './pages/CampaignNew';
import CampaignDetail from './pages/CampaignDetail';
import NicheCategory from './pages/NicheCategory';
import Embed from './pages/Embed';

// Blog pages
import BlogIndex from './pages/blog/BlogIndex';
import LinkBuildingPricing from './pages/blog/LinkBuildingPricing';
import HowMuchDoBacklinksCost from './pages/blog/HowMuchDoBacklinksCost';
import LinkBuildingCost from './pages/blog/LinkBuildingCost';
import BacklinkPrices from './pages/blog/BacklinkPrices';
import GuestPostSeo from './pages/blog/GuestPostSeo';
import StateOfGuestPostPricing from './pages/blog/StateOfGuestPostPricing';
import CollaboratorVsWhitePress from './pages/blog/CollaboratorVsWhitePress';
import WhitePressAlternatives from './pages/blog/WhitePressAlternatives';
import CollaboratorReview from './pages/blog/CollaboratorReview';
import AdsyReview from './pages/blog/AdsyReview';
import SerpzillaReview from './pages/blog/SerpzillaReview';
import NicheEditVsGuestPost from './pages/blog/NicheEditVsGuestPost';
import GuestPostOutreach from './pages/blog/GuestPostOutreach';
import BuyBacklinksCheap from './pages/blog/BuyBacklinksCheap';
import NicheEdits from './pages/blog/NicheEdits';
import GuestPostSites from './pages/blog/GuestPostSites';

// Programmatic SEO pages
import MarketplaceDetail from './pages/MarketplaceDetail';
import Alternatives from './pages/Alternatives';

// Old pages (kept for now, will be replaced in later stages)
import Discover from './pages/Discover';
import Alerts from './pages/Alerts';
import WatchlistPage from './pages/Watchlist';
import CompetitorAnalysis from './pages/CompetitorAnalysis';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import Billing from './pages/Billing';
import Settings from './pages/Settings';
import ApiKeys from './pages/ApiKeys';
import History from './pages/History';
import SavedLists from './pages/SavedLists';

// Admin pages
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminUsers from './pages/admin/AdminUsers';
import AdminDomains from './pages/admin/AdminDomains';
import AdminSellers from './pages/admin/AdminSellers';
import AdminSubmissions from './pages/admin/AdminSubmissions';
import AdminMonitor from './pages/admin/AdminMonitor';
import AdminScraping from './pages/admin/AdminScraping';
import AdminPartners from './pages/admin/AdminPartners';

function App() {
  return (
    <Routes>
      {/* PUBLIC — The tool is the homepage */}
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/submit" element={<Submit />} />
      <Route path="/docs" element={<ApiDocs />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/partners" element={<Partners />} />
      <Route path="/mcp-server" element={<McpServer />} />
      <Route path="/why-free" element={<WhyFree />} />
      <Route path="/serp" element={<SerpScanner />} />
      <Route path="/vs" element={<Compare />} />
      <Route path="/vs/:competitor" element={<Compare />} />
      <Route path="/compare" element={<Navigate to="/vs" replace />} />
      <Route path="/compare/:competitor" element={<Navigate to="/vs" replace />} />
      <Route path="/auth/:provider/callback" element={<OAuthCallback />} />

      {/* PUBLIC — Blog */}
      <Route path="/blog" element={<BlogIndex />} />
      <Route path="/blog/link-building-pricing" element={<LinkBuildingPricing />} />
      <Route path="/blog/how-much-do-backlinks-cost" element={<HowMuchDoBacklinksCost />} />
      <Route path="/blog/link-building-cost" element={<LinkBuildingCost />} />
      <Route path="/blog/backlink-prices" element={<BacklinkPrices />} />
      <Route path="/blog/guest-post-seo" element={<GuestPostSeo />} />
      <Route path="/blog/state-of-guest-post-pricing-2026" element={<StateOfGuestPostPricing />} />
      <Route path="/blog/collaborator-vs-whitepress" element={<CollaboratorVsWhitePress />} />
      <Route path="/blog/whitepress-alternatives" element={<WhitePressAlternatives />} />
      <Route path="/blog/collaborator-review" element={<CollaboratorReview />} />
      <Route path="/blog/adsy-review" element={<AdsyReview />} />
      <Route path="/blog/serpzilla-review" element={<SerpzillaReview />} />
      <Route path="/blog/niche-edit-vs-guest-post" element={<NicheEditVsGuestPost />} />
      <Route path="/blog/guest-post-outreach" element={<GuestPostOutreach />} />
      <Route path="/blog/buy-backlinks-cheap" element={<BuyBacklinksCheap />} />
      <Route path="/blog/niche-edits" element={<NicheEdits />} />
      <Route path="/blog/guest-post-sites" element={<GuestPostSites />} />

      {/* PUBLIC — Niche + Embed */}
      <Route path="/niche" element={<NicheCategory />} />
      <Route path="/niche/:niche" element={<NicheCategory />} />
      <Route path="/embed" element={<Embed />} />

      {/* PUBLIC — Domain detail + Browse */}
      <Route path="/domain/:domainName" element={<DomainDetail />} />
      <Route path="/browse" element={<BrowseNiche />} />
      <Route path="/bulk-checker" element={<BulkCheck />} />
      <Route path="/marketplaces" element={<Marketplaces />} />
      <Route path="/marketplaces/:marketplace" element={<MarketplaceDetail />} />
      <Route path="/alternatives/:subject" element={<Alternatives />} />
      <Route path="/bulk" element={<Navigate to="/bulk-checker" replace />} />

      {/* LOGGED IN — Watchlist, settings */}
      <Route path="/watchlist" element={<ProtectedRoute><WatchlistPage /></ProtectedRoute>} />
      <Route path="/competitor" element={<ProtectedRoute><CompetitorAnalysis /></ProtectedRoute>} />
      <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
      <Route path="/billing" element={<ProtectedRoute><Billing /></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
      <Route path="/api-keys" element={<ProtectedRoute><ApiKeys /></ProtectedRoute>} />
      <Route path="/history" element={<ProtectedRoute><History /></ProtectedRoute>} />
      <Route path="/saved" element={<ProtectedRoute><SavedLists /></ProtectedRoute>} />
      <Route path="/campaigns" element={<ProtectedRoute><Campaigns /></ProtectedRoute>} />
      <Route path="/campaigns/new" element={<ProtectedRoute><CampaignNew /></ProtectedRoute>} />
      <Route path="/campaigns/:id" element={<ProtectedRoute><CampaignDetail /></ProtectedRoute>} />

      {/* Keep old dashboard route working */}
      <Route path="/dashboard" element={<Navigate to="/" replace />} />
      <Route path="/discover" element={<Navigate to="/browse" replace />} />
      <Route path="/alerts" element={<Navigate to="/watchlist" replace />} />

      {/* ADMIN */}
      <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
      <Route path="/admin/users" element={<AdminRoute><AdminUsers /></AdminRoute>} />
      <Route path="/admin/domains" element={<AdminRoute><AdminDomains /></AdminRoute>} />
      <Route path="/admin/sellers" element={<AdminRoute><AdminSellers /></AdminRoute>} />
      <Route path="/admin/submissions" element={<AdminRoute><AdminSubmissions /></AdminRoute>} />
      <Route path="/admin/monitor" element={<AdminRoute><AdminMonitor /></AdminRoute>} />
      <Route path="/admin/scraping" element={<AdminRoute><AdminScraping /></AdminRoute>} />
      <Route path="/admin/partners" element={<AdminRoute><AdminPartners /></AdminRoute>} />

      {/* Catch all */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
